import { useTranslation } from "react-i18next";
import { useLanguageStore } from "../../../core/store/languageStore";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const { language, setLanguage } = useLanguageStore();

  const handleLanguageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newLanguage = e.target.value;
    i18n.changeLanguage(newLanguage);
    setLanguage(newLanguage);
  };

  return (
    <select
      id="language"
      value={language}
      onChange={handleLanguageChange}
      className="custom-select mt-1 block w-full rounded-md border-gray-300 dark:border-gray-600 bg-gray-100 dark:bg-gray-700 p-2 text-gray-900 dark:text-white"
    >
      <option value="fr">🇫🇷 &nbsp; Français</option>
      <option value="en">🇬🇧 &nbsp; English</option>
      <option value="es">🇪🇸 &nbsp; Español</option>
    </select>
  );
};

export default LanguageSwitcher;
